import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { ToastModule } from "primeng/toast";
import { SharedModule } from "../shared/shared.module";
import { LoginFormComponent } from "./login/login-form/login-form.component";
import { LoginComponent } from "./login/login.component";
import { TokenInterceptor } from "./token.interceptor";
import { TokenService } from "./token.service";

const routes: Routes = [
  {
    path: "",
    component: LoginComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
];

@NgModule({
  declarations: [LoginComponent, LoginFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule.forChild(routes),
    ToastModule,
    SharedModule,
  ],
  exports: [LoginComponent],
  providers: [
    FormBuilder,
    TokenService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  ],
})
export class AuthModule {}
